export default __webpack_public_path__ + "static/media/germany_icon.bdd3cf7b.png";